import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const state = {
    documents: [],
    calculations: [],
    pagination: [],
    clientSpecificFields: [],
    displaySettings: []
};

const getters = {
    getDocuments: (state) => state.documents,
    getCalculations: (state) => state.calculations,
    getPagination: (state) => state.pagination,
    getClientSpecificFields: (state) => state.clientSpecificFields,
    getDisplaySettings: (state) => state.displaySettings
};

const actions = {
  async getDocumentsForBatchInsert(context, data) {
      return await axios.post(`${backendUrl()}/getDocumentsForBatchInsert`,
      {
          sessionToken: vuecookie.get('token'),
          page: data.page,
          perPage: data.per_page,
          batchId: data.batch_id,
          sortField: data.sort_field,
          sortDirection: data.sort_direction,
          docs: data.docs,
          businessUnits: data.business_unit_filter,
          //Determines if we must search by exact customer reference
          exactCustRef: data.exact_cust_ref,
          //Search for customer reference "is"
          customerReference: data.customer_reference,
          //Search for customer reference "contains"
          customerRef: data.customer_ref,
          customerName: data.customer_name,
          docPages: data.doc_pages,
          docRefBegins: data.doc_ref_begins,
          docRefContains: data.doc_ref_contains,
          docId: data.doc_id
      },
      {
          headers: {'Authorization': "bearer " + vuecookie.get('token')}
      })
      .then(response => {
          if(response.data.status == 'error'){
            context.dispatch('handleResponse', response, {root: true})
          } else {
            context.commit('setDocuments', response.data.documents)
            context.commit('setPagination', response.data.pagination)
            context.commit('setCalculations', response.data.calculations)
          }

          return response.data
      })
  },
  async batchInsert(context, data) {
      await axios.post(`${backendUrl()}/batchInsert`, data,
      {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': "bearer " + vuecookie.get('token')
          }
      })
      .then(response => {
          //console.log(response.data)
          context.dispatch('handleResponse', response, {root: true})
      })
  },
  async getClientSpecificFields(context, data) {
      return await axios.post(`${backendUrl()}/getClientSpecificFields/${data.view}`,
      {
          sessionToken: vuecookie.get('token')
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          return response.data
      })
  },
  async getDisplaySettings(context, data) {
      await axios.post(`${backendUrl()}/getDisplaySettingsForBatchInsert`,
      {
          sessionToken: vuecookie.get('token')
      },
      {
          headers: { 'Authorization': "bearer " + vuecookie.get('token') }
      })
      .then(response => {
          context.commit('setDisplaySettings', response.data)
      })
  }
};

const mutations = {
  setDocuments:(state, documents) => (state.documents = documents),
  setCalculations:(state, calculations) => (state.calculations = calculations),
  setPagination: (state, pagination) => (state.pagination = pagination),
  setClientSpecificFields: (state, fields) => (state.clientSpecificFields = fields),
  setDisplaySettings: (state, settings) => (state.displaySettings = settings)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
